<template>
    <div id="body">
        <b-container>
            <b-row class="d-lex justify-content-center mt-5">
                <b-col lg="8">
                    <div class="box-tks mt-5 p-5 h2 text-center d-flex align-items-center justify-content-center">
                        <div class="text-center">
                            <p>Cảm ơn bạn đã hoàn thành xuất sắc bài thi.</p>
                            <p>Rất mong được đồng hành với bạn trong thời gian tới!</p>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    computed: {
        pageSlug() {
            return this.$route.params.slug
        }
    }
}
</script>

<style lang="scss" scoped>
.box-tks {
    background-color: #fee138;
    border-radius: 42px;
    color: #0057a7;
    min-height: 400px;
}

.box-tks p {
    font-size: 25px;
    text-align: center;
    font-weight: 800;
    text-shadow: 2px 2px #fff,
                 2px -2px #fff,
                -2px 2px #fff,
                -2px -2px #fff;
}

@media only screen and (max-width: 768px) {
    #body {
        height: 85vh;
    }
}
</style>
